// extracted by mini-css-extract-plugin
export default {"div":"confirm_div__y1+RT","list":"confirm_list__FLJn1"};